import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// import { viewAllLatestBlogsData } from "../../common";
// core components
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import SoftwareTeamHunt from "../../components/CaseStudy/SoftwareTeamHunt";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
import ContactBanner from "../../components/banner/ContactBanner";
import BlogCard from "../../components/OurLatestBlogs/BlogCard";
// import userImg1 from '../../assets/images/blog/blog-home/b-01.webp';
import { Container, Form, FormGroup, Input, Label } from "reactstrap";
// import { getIPGeoLocation } from "../../common/GeneralUtils";
import axios from "axios";
// import { useLocation } from "react-router-dom";

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const SoftwareTeamHunt = Loadable(
//     lazy(() => import('../../components/CaseStudy/SoftwareTeamHunt'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )
// const ContactBanner = Loadable(
//     lazy(() => import('../../components/banner/ContactBanner'))
// )
// const BlogCard = Loadable(
//     lazy(() => import('../../components/OurLatestBlogs/BlogCard'))
// )
// const userImg1 = Loadable(
//     lazy(() => import('../../assets/images/blog/blog-home/b-01.webp'))
// )

const ViewBlogScreen = () => {
    // const location = useLocation()
    const [blogsData, setBlogsData] = useState([]);
    const [ContactPageData, setData] = useState({});
    const [viewAllLatestBlogsData, setViewAllLatestBlogsData] = useState({});
    // const [geoLocationData, setGeoLocationData] = useState(null);


    const getAllContactPageData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/contactPageData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    const getAllViewAllLatestBlogsData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/viewAllLatestBlogsData.json');
            setViewAllLatestBlogsData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        const getBlogs = async () => {
            try {
                const res = await axios.get('/staticDataFiles/data.json');
                const mapped = res.data.map((blog) => ({
                    id: blog?.id,
                    name: blog?.bannerData?.text,
                    createdDate: blog?.bannerData?.subTitle,
                    userImg: blog?.headerData?.image,
                    paragraph: blog?.bannerData?.title,
                    heading: blog?.headerData?.title,
                    subTitle: blog?.headerData?.paragraph,
                }));
                setBlogsData(mapped);
            } catch (err) {
                console.error('Error fetching blogs:', err);
            }
        };
        getAllContactPageData();
        getAllViewAllLatestBlogsData();
        getBlogs();
        // getIPGeoLocation(location.pathname)
    }, []);

    return (
        <div id="main-wrapper">
            <Header />
            <div className="page-wrapper view-all-blogs">
                <div className="container-fluid">
                    <div className="project-page">
                        <ContactBanner bannerImg={viewAllLatestBlogsData?.bannerImg} data={viewAllLatestBlogsData?.headerData} />
                        <Container className="page-blog-content py-3">
                            <Form className="d-flex align-items-center flex-wrap justify-content-center gap-3 w-75 m-auto">
                                <Label htmlFor="name">Filter by :</Label>
                                <FormGroup className="form-input m-t-15 w-25">
                                    <Input type="select" className="py-2" name="Budget" id="exampleSelect" placeholder="Tag">
                                        <option>Tag</option>
                                        {viewAllLatestBlogsData?.tags?.map((tag, index) => {
                                            return (
                                                <option key={index} value={tag.value}>{tag.label}</option>
                                            )
                                        })}
                                    </Input>
                                </FormGroup>
                                <FormGroup className="form-input m-t-15 w-25">
                                    <Input className="py-2" type="date" name="Budget" id="exampleSelect" />
                                </FormGroup>
                            </Form>
                            <div className="py-3">
                                <BlogCard data={blogsData} />
                            </div>
                        </Container>
                        <SoftwareTeamHunt data={viewAllLatestBlogsData?.softwareTeamHunt} />
                        <CustomerReviews />
                        <FrequentlyAskedQuestions faqData={ContactPageData?.FrequentlyAskedQuestionsData} />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

ViewBlogScreen.propTypes = {
    classes: PropTypes.object
};

export default ViewBlogScreen;
